export default __webpack_public_path__ + "assets/img/line-awesome.4b43b038741cb489a5027a5c8ab14fb9.woff2";